import {mapState, mapActions} from 'vuex';
const forEach = require('lodash/forEach');

export default {
    data() {
        return {
            errors: {},
        }
    },
    methods: {
        createErrors(data) {
            if (data === undefined) {
                return;
            }

            let arrays = Object.keys(data);

            let header = arrays[0].split('.');

            if (header.length === 3) {
                this.errors[header[0]][header[1]][header[2]]['isError'] = true;
            } else if (header.length === 2) {
                this.errors[header[0]][header[1]]['isError'] = true;
            } else {
                this.errors[header[0]]['isError'] = true;
            }

            forEach(data, (error, key) => {
                let arr = key.split('.');

                if(arr.length === 3) {
                    let error = this.errors[arr[0]][arr[1]][arr[2]];

                    if (error['message'].length === 0) {
                        error['message'] = error[0];
                    }

                    error['isErrorPaint'] = true;
                } else if (arr.length === 2) {
                    this.errors[arr[0]][arr[1]]['message'] = error[0];
                    this.errors[arr[0]][arr[1]]['isErrorPaint'] = true;
                } else {
                    this.errors[key]['message'] = error[0];
                    this.errors[key]['isErrorPaint'] = true;
                }
            });
        },
        clearErrors() {
            forEach(this.errors, (error, key) => {
                forEach(error, (error2, key2) => {
                    if (typeof (error2) === 'object') {
                        this.errors[key][key2]['isError'] = false;
                        this.errors[key][key2]['isErrorPaint'] = false;
                    }

                    forEach(error2, (error3, key3) => {
                        if (typeof (error3) === 'object') {
                            this.errors[key][key2][key3]['isError'] = false;
                            this.errors[key][key2][key3]['isErrorPaint'] = false;
                        }
                    });
                });
                this.errors[key]['isError'] = false;
                this.errors[key]['isErrorPaint'] = false;
            });
        },
        createErrorsValid(errors) {
            let field = errors[0].field;
            let arr = field.split('.');

            if (arr.length === 2) {
                this.errors[arr[0]][arr[1]]['isError'] = true;
            } else {
                this.errors[field].isError = true;
            }

            forEach(errors, (error) => {
                let arr = error.field.split('.');

                if (arr.length === 2) {
                    this.errors[arr[0]][arr[1]]['message'] = error.message;
                    this.errors[arr[0]][arr[1]]['isErrorPaint'] = true;
                } else {
                    this.errors[error.field]['message'] = error.message;
                    this.errors[error.field]['isErrorPaint'] = true;
                }
            });
        },
        clearErrorsValid(errors) {
            forEach(this.errors, (error, key) => {
                if (key == 'start' || key == 'end') {
                    this.errors[key]['day']['isError'] = false;
                    this.errors[key]['day']['isErrorPaint'] = false;
                    this.errors[key]['month']['isError'] = false;
                    this.errors[key]['month']['isErrorPaint'] = false;
                    this.errors[key]['year']['isError'] = false;
                    this.errors[key]['year']['isErrorPaint'] = false;
                } else if (key == 'place') {
                    this.errors[key]['details']['isError'] = false;
                } else {
                    this.errors[key]['isError'] = false;
                    this.errors[key]['isErrorPaint'] = false;
                }

            });
        },
        clearErrorsFilter() {
            forEach(this.errors, (error, key) => {
                forEach(error, (error2, key2) => {
                    this.errors[key][key2]['isError'] = false;
                });
            });
        },
    }
};
